import { VFC } from 'react';
import { Descriptions, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useMeterModel } from 'hooks/meter_models/useMeterModel';
import { LoadingSpinner } from 'components/LoadingSpinner';
import { useStore } from '../../useStore';
import { InstallationTechnology } from '../../const/installationTechnology';
import { useInstallMeterStepsStore } from '../../components/store';
import { InstallationTechnologyButton } from './Button';
import { InstallationTechnologyStepContent as messages } from './messages';
import { useMeterModelSuggestions } from '../../../../hooks/meter_models/useMeterModelDetails';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';

export const InstallationTechnologyStepContent: VFC = () => {
  const { enmonMeter, setInstallationTechnologyStepValues } = useStore();
  const { setMeterModelSuggestions } = useMeterModelSuggestionsStore();
  const { setNextStep } = useInstallMeterStepsStore();

  const { serial: serialNumber, toolsId: strapiId, meterModel } = enmonMeter ?? {};
  const { data: meterModelData, isLoading } = useMeterModel(meterModel);
  const meterModelSuggestions = useMeterModelSuggestions(meterModelData);

  const handleClick = (technology: InstallationTechnology) => {
    setInstallationTechnologyStepValues({ installationTechnology: technology });
    if (meterModelSuggestions) {
      setMeterModelSuggestions(meterModelSuggestions);
    }
    setNextStep();
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Space direction="vertical" size="large" style={{ display: 'flex', alignItems: 'stretch' }}>
      <Descriptions
        bordered
        column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
        size="small"
        title={<FormattedMessage {...messages.title} />}
      >
        <Descriptions.Item label={<FormattedMessage {...messages.strapiId} />}>{strapiId}</Descriptions.Item>
        <Descriptions.Item label={<FormattedMessage {...messages.sn} />}>{serialNumber}</Descriptions.Item>
      </Descriptions>
      <InstallationTechnologyButton technology={InstallationTechnology.LoraWan} onClick={handleClick} />
      <InstallationTechnologyButton technology={InstallationTechnology.NBIoT} onClick={handleClick} />
      <InstallationTechnologyButton technology={InstallationTechnology.Other} onClick={handleClick} />
    </Space>
  );
};
